import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IKhuCongNghiep } from 'app/shared/model/khu-cong-nghiep.model';
import { searchEntities, getEntities } from './khu-cong-nghiep.reducer';

export const KhuCongNghiep = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const khuCongNghiepList = useAppSelector(state => state.khuCongNghiep.entities);
  const loading = useAppSelector(state => state.khuCongNghiep.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="khu-cong-nghiep-heading" data-cy="KhuCongNghiepHeading">
        <Translate contentKey="xtdtApp.khuCongNghiep.home.title">Khu Cong Nghieps</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.khuCongNghiep.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/khu-cong-nghiep/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.khuCongNghiep.home.createLabel">Create new Khu Cong Nghiep</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.khuCongNghiep.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {khuCongNghiepList && khuCongNghiepList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.ten">Ten</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.hinhAnhKhuCongNghiep">Hinh Anh Khu Cong Nghiep</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.diaDiem">Dia Diem</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.chuDauTu">Chu Dau Tu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.hinhAnhViTriDiaLy">Hinh Anh Vi Tri Dia Ly</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.moTaViTriDiaLy">Mo Ta Vi Tri Dia Ly</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.hinhAnhDienTich">Hinh Anh Dien Tich</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.moTaDienTich">Mo Ta Dien Tich</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.tongVonDauTu">Tong Von Dau Tu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.trangThaiHoatDong">Trang Thai Hoat Dong</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.mucTieu">Muc Tieu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.danhMucNganhNgheUuTien">Danh Muc Nganh Nghe Uu Tien</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.nguonDien">Nguon Dien</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.nguonNuoc">Nguon Nuoc</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.heThongThoatNuocXuLyChatThai">He Thong Thoat Nuoc Xu Ly Chat Thai</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.vienThong">Vien Thong</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.haTangXaHoiVaDichVu">Ha Tang Xa Hoi Va Dich Vu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.giaChoThue">Gia Cho Thue</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.uuDaiDauTu">Uu Dai Dau Tu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.geometry">Geometry</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.diaPhuong">Dia Phuong</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.khuCongNghiep.doanhNghiep">Doanh Nghiep</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {khuCongNghiepList.map((khuCongNghiep, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/khu-cong-nghiep/${khuCongNghiep.id}`} color="link" size="sm">
                      {khuCongNghiep.id}
                    </Button>
                  </td>
                  <td>{khuCongNghiep.ten}</td>
                  <td>{khuCongNghiep.hinhAnhKhuCongNghiep}</td>
                  <td>{khuCongNghiep.diaDiem}</td>
                  <td>{khuCongNghiep.chuDauTu}</td>
                  <td>{khuCongNghiep.hinhAnhViTriDiaLy}</td>
                  <td>{khuCongNghiep.moTaViTriDiaLy}</td>
                  <td>{khuCongNghiep.hinhAnhDienTich}</td>
                  <td>{khuCongNghiep.moTaDienTich}</td>
                  <td>{khuCongNghiep.tongVonDauTu}</td>
                  <td>
                    <Translate contentKey={`xtdtApp.TrangThaiHoatDongEnum.${khuCongNghiep.trangThaiHoatDong}`} />
                  </td>
                  <td>{khuCongNghiep.mucTieu}</td>
                  <td>{khuCongNghiep.danhMucNganhNgheUuTien}</td>
                  <td>{khuCongNghiep.nguonDien}</td>
                  <td>{khuCongNghiep.nguonNuoc}</td>
                  <td>{khuCongNghiep.heThongThoatNuocXuLyChatThai}</td>
                  <td>{khuCongNghiep.vienThong}</td>
                  <td>{khuCongNghiep.haTangXaHoiVaDichVu}</td>
                  <td>{khuCongNghiep.giaChoThue}</td>
                  <td>{khuCongNghiep.uuDaiDauTu}</td>
                  <td>{khuCongNghiep.geometry}</td>
                  <td>
                    {khuCongNghiep.diaPhuong ? (
                      <Link to={`/don-vi-hanh-chinh/${khuCongNghiep.diaPhuong.id}`}>{khuCongNghiep.diaPhuong.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {khuCongNghiep.doanhNghieps
                      ? khuCongNghiep.doanhNghieps.map((val, j) => (
                          <span key={j}>
                            <Link to={`/doanh-nghiep/${val.id}`}>{val.id}</Link>
                            {j === khuCongNghiep.doanhNghieps.length - 1 ? '' : ', '}
                          </span>
                        ))
                      : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/khu-cong-nghiep/${khuCongNghiep.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/khu-cong-nghiep/${khuCongNghiep.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/khu-cong-nghiep/${khuCongNghiep.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.khuCongNghiep.home.notFound">No Khu Cong Nghieps found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default KhuCongNghiep;
